import {Component, OnDestroy, OnInit} from '@angular/core';
import {LanguageService} from "../../../shared/services/language/language.service";
import {Subscription} from "rxjs/Subscription";

@Component({
    selector: 'app-not-found',
    templateUrl: './not-found.component.html',
    styleUrls: ['./not-found.component.scss']
})
export class NotFoundComponent implements OnInit, OnDestroy {

    private languageSubscripton: Subscription;
    public currentLanguage = 'en';

    constructor(private languageService: LanguageService) {
    }

    ngOnInit() {
        this.subscribeLanguageEvents();
    }


    ngOnDestroy(): void {
        this.unsubscribeLanguageEvents();
    }

    private subscribeLanguageEvents() {
        this.languageSubscripton = this.languageService.language.subscribe((val) => {
            this.currentLanguage = val;
        });
    }

    private unsubscribeLanguageEvents() {
        this.languageSubscripton.unsubscribe();
    }
}



// WEBPACK FOOTER //
// /var/www/luvi/frontend/src/app/components/public/not-found/not-found.component.ts